import React from "react";
import "./AboutUs.css";
import { useTranslation } from "react-i18next";
import aboutImg from "../../../../../assets/images/aboutUs.png"

function AboutUsSection() {
    const { t } = useTranslation("home");
  return (
    <section className="aboutUs-section">
      <div className="container">
        <div>
          <h2>{t("aboutSection.heading")}</h2>
          <p>
            {t("aboutSection.firstP")}
          </p>
          <p>
            {t("aboutSection.secoundP")}
          </p>
        </div>
        <img src={aboutImg} alt="" srcset="" />
      </div>
    </section>
  );
}

export default AboutUsSection;
